import { defineComponent as c, ref as m, onMounted as f, computed as u } from "vue";
import h from "./td-longtail-vue-components94.js";
import v from "./td-longtail-vue-components9.js";
import y from "./td-longtail-vue-components5.js";
import b from "./td-longtail-vue-components6.js";
import H from "./td-longtail-vue-components33.js";
const k = /* @__PURE__ */ c({
  __name: "image-teaser",
  props: {
    background: { default: void 0 },
    heading: { default: void 0 },
    image: { default: void 0 },
    lazy: { type: Boolean },
    description: { default: void 0 },
    hasBadge: { type: Boolean },
    teaserHeightXs: { default: "380px" },
    teaserHeightSm: { default: "400px" },
    teaserHeightMd: { default: void 0 },
    teaserHeightLg: { default: void 0 },
    positionY: { default: "" },
    positionYDesktop: { default: "" },
    theme: { default: void 0 },
    animateTile: { type: Boolean },
    animateImage: { type: Boolean },
    animationDelay: { default: 1 },
    animationContent: { default: () => ({
      start: "top bottom",
      end: "top center",
      vars: { yPercent: 20 }
    }) }
  },
  setup(p, { expose: d }) {
    const e = p, a = m(null), o = m(null), n = m(null), { createScrollTrigger: t, createTweenFrom: i } = h(), s = () => {
      e.animationContent && a.value && t({
        trigger: a.value,
        start: e.animationContent.start,
        end: e.animationContent.end,
        scrub: 1,
        animation: i(a.value, e.animationContent.vars)
      }), e.animateTile && o.value && t({
        trigger: o.value,
        start: "top bottom",
        end: "center-=25% bottom",
        scrub: 1,
        animation: i(o.value, {
          yPercent: 15 * e.animationDelay
        })
      }), e.animateImage && n.value && t({
        trigger: n.value.$el,
        start: "top bottom",
        end: "center-=25% bottom",
        scrub: 1,
        animation: i(n.value.$el, {
          yPercent: 15 * e.animationDelay
        })
      });
    };
    f(() => {
      setTimeout(s, 1);
    });
    const g = u(() => ({
      "--teaser-height-xs": e.teaserHeightXs,
      "--teaser-height-sm": e.teaserHeightSm,
      "--teaser-height-md": e.teaserHeightMd,
      "--teaser-height-lg": e.teaserHeightLg
    })), l = u(() => {
      const r = [];
      return e.theme && r.push(`text--${e.theme}`), e.positionY && r.push(`image-teaser--${e.positionY}`), e.positionYDesktop && r.push(`image-teaser--desktop-${e.positionYDesktop}`), r;
    });
    return d({ startAnimation: s, componentClass: l, createScrollTrigger: t }), { __sfc: !0, props: e, containerElement: a, imageTeaserElement: o, imageElement: n, createScrollTrigger: t, createTweenFrom: i, startAnimation: s, componentStyles: g, componentClass: l, PictureElement: v, Paragraph: y, Heading: b, Badge: H };
  }
});
export {
  k as default
};
